import { SxProps, Theme } from '@mui/material';

export const WATERSHED_BIG_ROCK_DATA_GRID_ROW_HEIGHT = 40; // to replace the standard row height when launched

/**
 * This styling object will be mixed into the normal styling in Mui's DataGrid when Big Rocks redesign is on.
 */
export const bigRockSx: SxProps<Theme> = {
  // Border radius on selected cells
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader.pseudo-focus, & .pseudo-focus-all .MuiDataGrid-columnHeader, & .MuiDataGrid-cell:focus, & .MuiDataGrid-cell.pseudo-focus, & .pseudo-focus-all .MuiDataGrid-cell':
    {
      backgroundColor: (theme) => theme.palette.grey10,
      borderRadius: 1,
      outlineOffset: '-1.5px',
      borderRightColor: 'transparent',
      position: 'relative',
      overflow: 'visible',
    },

  // More consistent border on bottom of column headers
  '& .MuiDataGrid-columnHeaders': {
    borderBottom: (theme) => `1px solid ${theme.palette.border}`,
  },

  // Consistent color and padding for all headers
  '& .MuiDataGrid-columnHeader': {
    borderRight: (theme) => `1px solid ${theme.palette.border}`,
    backgroundColor: (theme) => theme.palette.grey10,
    color: (theme) => theme.palette.grey70,
    padding: '12px',
  },

  // Consistent color and padding for all cells
  '& .MuiDataGrid-cell': {
    borderRight: (theme) => `1px solid ${theme.palette.border}`,
    borderBottomWidth: 0,
    color: (theme) => theme.palette.grey100,
    padding: '8px 12px',
  },

  // Ensure the column separator is 1px wide and plays well with padding placement wise
  '& .MuiDataGrid-columnSeparator': {
    right: '-14px',
    transform: 'scaleY(5) scaleX(0.5)', // 2 px wide in svg, we want 1px
  },

  // Pinned left columns have a box shadow on the right
  '& .MuiDataGrid-pinnedColumns--left, & .MuiDataGrid-pinnedColumnHeaders--left':
    {
      boxShadow: `1px 0px 4px 0px rgba(0, 0, 0, 0.06)`,
    },

  // Pinned right columns have a box shadow on the left
  '& .MuiDataGrid-pinnedColumns--right, & .MuiDataGrid-pinnedColumnHeaders--right':
    {
      boxShadow: `-2px 0px 4px 0px rgba(0, 0, 0, 0.06)`,
    },

  // Sort/menu icons need these to be visible when unsorted!
  '& .MuiDataGrid-iconButtonContainer': {
    visibility: 'visible',
    marginLeft: '8px',
  },
  '& .MuiDataGrid-menuIcon': {
    width: 'initial !important',
  },
  '& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIcon': {
    opacity: 'inherit !important',
  },
};
